module.exports = __webpack_public_path__ + "fonts/CircularStd-Bold.889a0a13.woff";